import {Component, OnInit} from '@angular/core';
import {ReviewState} from "../../review/models/review-state";
import {FacadeService} from "../../shared/service-facade/facade.service";
import { MainLayoutService } from 'src/app/shared/services/main-layout.service';
import {CoreService} from "../../shared/services/core.service";

@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.css']
})
export class SignupComponent implements OnInit {
  reviewState: ReviewState = ReviewState.Initial;
  shouldHideBsaQuestions: boolean = false;
  applicationHasCoApplicant = false;

  constructor(
    private facadeService: FacadeService,
    private mainLayout: MainLayoutService,
    private coreService: CoreService) {}

  ngOnInit(): void {
    this.setupComponents();

    this.coreService.disableBackButton();
  }

  setupComponents() {
    this.shouldHideBsaQuestions = this.facadeService.shouldHideBsaQuestions();
  }

  hasCoApplicant(value: boolean): void {
    this.applicationHasCoApplicant = value;
  }
}
